export const sectors = [
  {
    direction: "faq.sectors.directions.north",
    degree: "337,5–352,5",
    mountain: "faq.sectors.mountains.n1",
    name: "faq.sectors.names.n1",
    hieroglyph: "壬",
  },
  {
    degree: "352,5–7,5",
    mountain: "faq.sectors.mountains.n2",
    name: "faq.sectors.names.n2",
    hieroglyph: "子",
  },
  {
    degree: "7,5–22,5",
    mountain: "faq.sectors.mountains.n3",
    name: "faq.sectors.names.n3",
    hieroglyph: "癸",
  },
  {
    direction: "faq.sectors.directions.northeast",
    degree: "22,5–37,5",
    mountain: "faq.sectors.mountains.ne1",
    name: "faq.sectors.names.ne1",
    hieroglyph: "丑",
  },
  {
    degree: "37,5–52,5",
    mountain: "faq.sectors.mountains.ne2",
    name: "faq.sectors.names.ne2",
    hieroglyph: "艮",
  },
  {
    degree: "52,5–67,5",
    mountain: "faq.sectors.mountains.ne3",
    name: "faq.sectors.names.ne3",
    hieroglyph: "寅",
  },
  {
    direction: "faq.sectors.directions.east",
    degree: "67,5–82,5",
    mountain: "faq.sectors.mountains.e1",
    name: "faq.sectors.names.e1",
    hieroglyph: "甲",
  },
  {
    degree: "82,5–97,5",
    mountain: "faq.sectors.mountains.e2",
    name: "faq.sectors.names.e2",
    hieroglyph: "卯",
  },
  {
    degree: "97,5–112,5",
    mountain: "faq.sectors.mountains.e3",
    name: "faq.sectors.names.e3",
    hieroglyph: "乙",
  },
  {
    direction: "faq.sectors.directions.southeast",
    degree: "112,5–127,5",
    mountain: "faq.sectors.mountains.se1",
    name: "faq.sectors.names.se1",
    hieroglyph: "辰",
  },
  {
    degree: "127,5–142,5",
    mountain: "faq.sectors.mountains.se2",
    name: "faq.sectors.names.se2",
    hieroglyph: "巽",
  },
  {
    degree: "142,5–157,5",
    mountain: "faq.sectors.mountains.se3",
    name: "faq.sectors.names.se3",
    hieroglyph: "巳",
  },
  {
    direction: "faq.sectors.directions.south",
    degree: "157,5–172,5",
    mountain: "faq.sectors.mountains.s1",
    name: "faq.sectors.names.s1",
    hieroglyph: "丙",
  },
  {
    degree: "172,5–187,5",
    mountain: "faq.sectors.mountains.s2",
    name: "faq.sectors.names.s2",
    hieroglyph: "午",
  },
  {
    degree: "187,5–202,5",
    mountain: "faq.sectors.mountains.s3",
    name: "faq.sectors.names.s3",
    hieroglyph: "丁",
  },
  {
    direction: "faq.sectors.directions.southwest",
    degree: "202,5–217,5",
    mountain: "faq.sectors.mountains.sw1",
    name: "faq.sectors.names.sw1",
    hieroglyph: "未",
  },
  {
    degree: "217,5–232,5",
    mountain: "faq.sectors.mountains.sw2",
    name: "faq.sectors.names.sw2",
    hieroglyph: "坤",
  },
  {
    degree: "232,5–247,5",
    mountain: "faq.sectors.mountains.sw3",
    name: "faq.sectors.names.sw3",
    hieroglyph: "申",
  },
  {
    direction: "faq.sectors.directions.west",
    degree: "247,5–262,5",
    mountain: "faq.sectors.mountains.w1",
    name: "faq.sectors.names.w1",
    hieroglyph: "庚",
  },
  {
    degree: "262,5–277,5",
    mountain: "faq.sectors.mountains.w2",
    name: "faq.sectors.names.w2",
    hieroglyph: "酉",
  },
  {
    degree: "277,5–292,5",
    mountain: "faq.sectors.mountains.w3",
    name: "faq.sectors.names.w3",
    hieroglyph: "辛",
  },
  {
    direction: "faq.sectors.directions.northwest",
    degree: "292,5–307,5",
    mountain: "faq.sectors.mountains.nw1",
    name: "faq.sectors.names.nw1",
    hieroglyph: "戌",
  },
  {
    degree: "307,5–322,5",
    mountain: "faq.sectors.mountains.nw2",
    name: "faq.sectors.names.nw2",
    hieroglyph: "乾",
  },
  {
    degree: "322,5–337,5",
    mountain: "faq.sectors.mountains.nw3",
    name: "faq.sectors.names.nw3",
    hieroglyph: "亥",
  },
] as const;

export type Sector = (typeof sectors)[number];
